import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, Observable, of, ReplaySubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { serverLocation } from 'src/app/globals';
import { TokenService } from '../../shared/services/token.service';
import { OfferStatus } from '../classes';

@Injectable({
  providedIn: 'root'
})
export class OfferStatusService {

  offerStatus: { [key: number]: ReplaySubject<OfferStatus> } = { };

  private _allOfferStatusLoaded = new BehaviorSubject(false);
  allOfferStatusLoaded$ = this._allOfferStatusLoaded.asObservable();

  constructor(
    private _httpClient: HttpClient,
    private _tokenService: TokenService
  ) { }

  getAllOfferStatus(soft: boolean = true): Observable<OfferStatus[]> {
    if (!soft || !this._allOfferStatusLoaded.value) {
      return this._getAllOfferStatus().pipe(
        tap(
          (status: OfferStatus[]) => {
            status.forEach(x => {
              if(!soft && this.offerStatus[x.offerstateid]) this.offerStatus[x.offerstateid].next(x);
              else {
                if(!this.offerStatus[x.offerstateid]) this.offerStatus[x.offerstateid] = new ReplaySubject(1);
                this.offerStatus[x.offerstateid].next(x);
              }
            });
          }
        )
      );
    }
    return combineLatest(Object.values(this.offerStatus));
  }

  getOfferStatusById(identifier: number, soft: boolean = true): Observable<OfferStatus> {
    if(typeof identifier !== 'number') return of(null);
    if (!soft || !this.offerStatus[identifier]) {
      if (!this.offerStatus[identifier]) this.offerStatus[identifier] = new ReplaySubject(1);
      this._getOfferStatusById(identifier).subscribe({
        next: (status: OfferStatus) => this.offerStatus[identifier].next(status),
        error: (error: HttpErrorResponse) => this.offerStatus[identifier].error(error)
      });
    }
    return this.offerStatus[identifier].asObservable();
  }
  
  private _getAllOfferStatus(): Observable<OfferStatus[]> {
    return (this._httpClient.get(`api/issue-status`, {
      headers: new HttpHeaders().set('Authorization', `Bearer ${this._tokenService.token}`)
    }) as Observable<OfferStatus[]>).pipe(tap(() => this._allOfferStatusLoaded.next(true)));
  }

  private _getOfferStatusById(identifier: number): Observable<OfferStatus> {
    return this._httpClient.get(`${serverLocation}/api/offer-status/${identifier}`, {
      headers: new HttpHeaders().set('Authorization', `Bearer ${this._tokenService.token}`)
    }) as Observable<OfferStatus>;
  }
}
